<template>
  <div>
    <div class="card-container-header">Личный кабинет</div>
    <div class="cards-container">
      <a-card class="courses-card" :bordered="false">
        <div class="card-header">
          <div class="header-title-block">
            <div class="header-title">
              Развитие
            </div>

            <a-button @click="openStudy" class="secondary-button">
              Смотреть все
            </a-button>
          </div>
          <p class="additional-text">Список активных курсов и тренажеров</p>
        </div>

        <template v-if="courses && courses.length">
          <div class="course-blocks">
            <template v-for="(item, index) in courses" :key="item.url">
              <div v-if="(!showMoreCourses && index < 3) || showMoreCourses">
                  <div class="course-item">
                    <div class="course-header-block">
                      <div class="course-title">{{ item.title }}</div>
                      <a :href="item.url" target="_blank">
                        <RightOutlined />
                      </a>
                    </div>
                    <div class="course-progress">
                      <a-progress :stroke-color="'#21AC0C'" :percent="item.progress ?? 0"  :format="percent => `${percent}%`" />
                    </div>
                  </div>
              </div>
            </template>
          </div>

          <a-button @click="openStudy" class="secondary-button mobile-button">
            Смотреть все
          </a-button>
        </template>

        <div v-else class="no-items-block">
          <div>
            <img src="@/assets/images/no-products.svg" alt="Иконка сообщая об отсутствии продуктов">
          </div>
          <p>Вам еще не были назначены курсы и тренажеры</p>
        </div>
      </a-card>

      <a-card class="tests-card" :bordered="false">
        <div class="card-header">
          <div class="header-title-block">
            <div class="header-title">
              Оценка ЭИ
            </div>

            <a-button v-if="tests.length > 2 && !showMorePassings" @click="() => showMorePassings = true" class="secondary-button">
              Смотреть все
            </a-button>
          </div>
          <p class="additional-text">Ваши текущие и завершенные тестирования</p>
        </div>

        <div v-if="tests && tests.length" class="test-block">
          <template  v-for="(item, index) in tests" :key="item.code" >
            <div v-if="(!showMorePassings && index < 2) || showMorePassings" class="test-item">
              <div>
                <div class="course-title">{{ item.title }}</div>
                <div v-if="item.status !== 'finished'">
                  <p v-if="item.status === 'new'" class="additional-text">Необходимо пройти тестирование</p>
                  <p v-else class="additional-text">
                    Рекомендуется завершить тестирование
                  </p>
                </div>
                <div v-else>
                  <p class="additional-text">
                    Завершен {{ item.finished_at }}
                  </p>
                </div>
              </div>

              <div>
                <div v-if="item.status === 'finished' && (item.allow_view_report || getRight('admin'))">
                  <a-dropdown>
                    <a class="ant-dropdown-link" @click.prevent>
                      Скачать отчет
                      <DownOutlined />
                    </a>
                    <template #overlay>
                      <a-menu>
                        <a-menu-item :key="item.code">
                          <span @click="downloadReport(item.code)">
                            {{ item.title }}
                          </span>
                        </a-menu-item>
                      </a-menu>
                    </template>
                  </a-dropdown>
                </div>

                <a-button
                    v-else
                    size="small"
                    @click="openPassing(item.code)"
                    :class="[
                    'test-action-btn',
                      item.status === 'finished' ? 'btn-outline' : 'btn-filled'
                  ]">
                  {{ 'Пройти' }}
                </a-button>
              </div>
            </div>
          </template>
          <a-button v-if="tests.length > 2 && !showMorePassings" @click="() => showMorePassings = true" class="secondary-button mobile-button">
            Смотреть все
          </a-button>
        </div>
        <div v-else class="no-items-block">
          <div>
            <img src="@/assets/images/no-products.svg" alt="Иконка сообщая об отсутствии продуктов">
          </div>
          <p>Вам еще не были назначены тестирования</p>
        </div>
      </a-card>
    </div>
  </div>

</template>

<script>
import { CheckCircleFilled, PauseOutlined, DownOutlined, RightOutlined} from '@ant-design/icons-vue';
import NewsCommunity from "@/components/Cards/NewsCommunity.vue";
import {onBeforeMount, ref} from "@vue/runtime-core";
import useCheckRights from "@/mixins/useCheckRights";
import {useStore} from "vuex";
import {computed} from "@vue/reactivity";
import getReportName from "@/mixins/getReportName";
import {useRouter} from "vue-router";
import {message} from "ant-design-vue";

export default {
  name: 'MyDevelopment',
  components: {NewsCommunity, CheckCircleFilled, PauseOutlined, DownOutlined, RightOutlined},
  setup () {

    const {getRight} = useCheckRights(),
    router = useRouter();

    const showTestSummary = ref();
    const detailScores = ref();
    const store = useStore();
    const reportIsGenerating = ref(false);

    const showMoreCourses = ref(false);
    const showMorePassings = ref(false);

    const personalActivity = computed(() => store.state.personalActivity)

    const courses = ref([]);
    const tests = ref([]);

    const openPassing = (code) => {
        router.push('/passing/' + code);
    };

    const downloadReport = (code) => {
      reportIsGenerating.value = true;
      message.info('Идет генерация отчета, пожалуйста, подождите');

      store
          .dispatch("test/getReportLink", code)
          .then(({data}) => {
            if (data) {
              window.open(data, "Отчет");
            }
          }).finally(() => reportIsGenerating.value = false);
    };

    onBeforeMount(() => {
      store.commit("setIsGlobalLoad", true);

      store.dispatch('getPersonalActivity').then(() => {
        tests.value = personalActivity.value.passings?.map((passing) => {
           return {
             code: passing.code,
             title: getReportName(passing.report_type, true),
             finished_at: passing.finished_at,
             status: passing.status,
           }
        });

        courses.value = personalActivity.value.courses?.map((course) => {
          return {
            title: course.name,
            progress: course.percent_completed ?? 0,
            external_id: course.external_id,
            url: course.url ?? null,
          }
        });
      }).finally(() => store.commit("setIsGlobalLoad", false));
    });

    const openStudy = () => {
      window.open('https://study.way2wei.ru', '_blank')
    }

    return {
      courses,
      tests,
      openPassing,
      showTestSummary,
      detailScores,
      getRight,
      personalActivity,
      downloadReport,
      reportIsGenerating,
      showMoreCourses,
      showMorePassings,
      openStudy
    }
  }
}
</script>

<style lang="scss" scoped>

.card-container-header {
  display: none;

  @media (max-width: $tablet-breakpoint) {
    margin: 24px 0;
    font-size: 20px;
    text-align: left;
    font-weight: 500;
  }
}

.cards-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  width: 100%;
}

.courses-card,
.tests-card {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.courses-card :deep(.ant-card-body),
.tests-card :deep(.ant-card-body) {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.courses-card {
  border-radius: 8px;
  background: #fff;
}

.card-header {
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  text-align: left;
  font-weight: 600;
}

.course-item {
  text-align: left;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 8px;
}

.course-title {
  flex: 1;
  font-size: 14px;
  font-weight: 600;
  line-height: 120%;
  color: var(--main-font);
  white-space: wrap;
  text-align: left;
}

.course-progress {
  display: flex;
  align-items: center;
  gap: 8px;
}

.test-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 8px;
}

.test-status-badge {
  align-self: flex-start;
  font-size: 12px;
  padding: 0 8px;
  text-transform: lowercase;
}

.segmented-progress {
  display: flex;
  gap: 2px;
}

.segment-completed .segment.filled {
  background-color: var(--main-green);
}

.segment {
  width: 2px;
  height: 6px;
  background-color: #d9d9d9;
  transition: background-color 0.2s ease;
}

.segment.filled {
  background-color: var(--main-blue);
}

.progress-percent {
  font-size: 12px;
  color: #888;
}

.status-icon {
  display: flex;
  align-items: center;
}

.view-all-btn,
.view-all-header-btn {
  padding: 0;
  font-size: 14px;
  color: var(--main-font);
  border: 1px solid var(--grey-text);
  border-radius: 4px;
  text-align: center;
  width: 120px;
}

.view-all-btn:hover,
.view-all-header-btn:hover {
  background-color: var(--polar-green);
  color: var(--main-green);
}

.view-all-btn {
  display: none;
  margin-top: 20px;

  @media (max-width: 500px) {
    display: block;
  }
}

.view-all-header-btn {
  @media (max-width: 500px) {
    display: none;
  }
}

.test-action-btn {
  margin-top: 10px;
  align-self: flex-start;
  padding: 4px 12px;
  font-size: 13px;
  border-radius: 4px;
  height: auto;
  border: 1px solid transparent;
}

.btn-filled {
  background-color: var(--main-green);
  color: white;
}

.btn-filled:hover {
  border-color: var(--main-green);
  background-color: var(--polar-green-6);
  color: white;
}

.btn-outline {
  color: var(--main-green);
  border: 1px solid var(--main-green);
  background: transparent;
}

.btn-outline:hover {
  color: var(--main-green);
  border-color: var(--main-green);
  background-color: var(--polar-green);
}

@media (min-width: $tablet-breakpoint) {
  .cards-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
}

@media (max-width: $tablet-breakpoint) and (min-width: $mobile-breakpoint) {
  .cards-container {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .card-header {
    font-size: 15px;
  }

  .course-item,
  .test-item {
    padding: 10px 12px;
  }
}

@media (max-width: $mobile-breakpoint) {
  .cards-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .courses-card,
  .tests-card {
    box-shadow: none;
    border: 1px solid #f0f0f0;
  }

  .card-header {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  .course-item,
  .test-item {
    padding: 10px;
    gap: 15px;
  }

  .course-title {
    font-size: 13px;
    white-space: normal;
  }

  .test-status-badge {
    font-size: 11px;
  }

  .test-action-btn {
    width: 100%;
    text-align: center;
    font-size: 13px;
  }

  .view-all-btn {
    width: 100%;
    margin-top: 12px;
    font-size: 14px;
  }
}

.courses-card,
.tests-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 8px;
}

.course-item,
.test-item {
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  margin-bottom: 8px;
}

.no-items-block {
  padding: 40px 0;
  margin: auto;
}

.additional-text {
  color: var(--grey-text);
  margin-bottom: 0;
  text-align: left;
}

.ant-dropdown-link {
  color: var(--main-green);
}

.test-block,
.course-blocks {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 15px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
}

.header-title-block,
.course-header-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.download-report-button {
  margin-top: auto;
}

.secondary-button {
  @media (max-width: $mobile-breakpoint) {
    display: none;
  }
}

.secondary-button.mobile-button {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    display: block;
  }
}
</style>